import { Divider, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { cloneElement } from "react";
import {
  Button,
  Datagrid,
  Filter,
  FunctionField,
  ReferenceField,
  ResourceContextProvider,
  RowClickFunction,
  sanitizeListRestProps,
  SearchInput,
  ShowProps,
  TextField,
  TopToolbar,
  useListContext,
} from "react-admin";
import IconPlus from "@material-ui/icons/Add";
import { GridinRow, GridLabel } from "utils/style";
import StatusField from "components/StatusField";
import { availableOnlySuperAdminAndAdminAndFinance } from "utils/tools";
import { StyledList } from "../../components/ListWrapper";
import CustomPagination from "../../components/CustomPagination";

const ThisFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const ListActions = (props: any) => {
  const { className, exporter, filters, maxResults, history, ...rest } = props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: "button",
        })}

      <Button
        onClick={() =>
          history.push(
            `/personInCharges/create?source=${JSON.stringify({
              companyId: Number(props.filterValues?.CompanyId),
            })}&companyId=${Number(props.filterValues?.CompanyId)}`,
          )
        }
        label="Create Person In Charge"
      >
        <IconPlus />
      </Button>
    </TopToolbar>
  );
};

const PersonInCharge = (props: ShowProps) => {
  const rowClick: RowClickFunction = (id, basePath, record) =>
    `/personInCharges/${id}/show?companyId=${props.id}`;

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">Person In Charge</Typography>
      </Grid>
      <Grid item xs={12}>
        <ResourceContextProvider value="personInCharges">
          <StyledList
            {...props}
            exporter={false}
            hasCreate={false}
            filters={<ThisFilter />}
            filterDefaultValues={{ CompanyId: Number(props.id) }}
            bulkActionButtons={false}
            title=" "
            actions={
              availableOnlySuperAdminAndAdminAndFinance() ? (
                <ListActions history={props.history} />
              ) : null
            }
            pagination={<CustomPagination />}
          >
            <Datagrid rowClick={rowClick}>
              <FunctionField
                label="Person In Charge Info"
                render={() => (
                  <SanitizedGrid container spacing={2}>
                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Id :
                      </Typography>
                      <TextField source="id" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Name :
                      </Typography>
                      <FunctionField
                        render={(record: any) =>
                          `${record.firstName} ${record.lastName}`
                        }
                      />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Email :
                      </Typography>
                      <TextField source="user.email" emptyText="-" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Mobile :
                      </Typography>
                      <TextField source="mobile" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Mbc Code :
                      </Typography>
                      <TextField source="user.mbcCustomerId" />
                    </Grid>

                    <Grid item xs={12} style={GridinRow}>
                      <Typography variant="body2" style={GridLabel}>
                        Billing Name :
                      </Typography>
                      <TextField source="billingAddress.name" />
                    </Grid>
                  </SanitizedGrid>
                )}
              />
              <FunctionField
                label="Student Info"
                render={(record: any) => (
                  <>
                    {record.students && (
                      <SanitizedGrid container spacing={2}>
                        {record.students.length > 0 ? (
                          <>
                            {record.students.map(
                              (student: IStudent, index: number) => {
                                return (
                                  <>
                                    <Grid item xs={12} style={GridinRow}>
                                      <Typography variant="body2">
                                        Id : {student.id}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} style={GridinRow}>
                                      <Typography variant="body2">
                                        Name : {student.firstName}{" "}
                                        {student.lastName}
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={12} style={GridinRow}>
                                      <Typography
                                        variant="body2"
                                        style={GridLabel}
                                      >
                                        School :
                                      </Typography>
                                      <ReferenceField
                                        source={`students[${index}].schoolId`}
                                        reference="schools"
                                        emptyText="-"
                                        link={false}
                                      >
                                        <TextField source="name" />
                                      </ReferenceField>
                                    </Grid>

                                    <Grid item xs={4} style={GridinRow}>
                                      <Typography
                                        variant="body2"
                                        style={GridLabel}
                                      >
                                        Level :
                                      </Typography>
                                      <ReferenceField
                                        source={`students[${index}].levelId`}
                                        reference="levels"
                                        emptyText="-"
                                        link={false}
                                      >
                                        <TextField source="name" />
                                      </ReferenceField>
                                    </Grid>

                                    <Grid item xs={4} style={GridinRow}>
                                      <Typography
                                        variant="body2"
                                        style={GridLabel}
                                      >
                                        Class :
                                      </Typography>
                                      <ReferenceField
                                        source={`students[${index}].levelGroupId`}
                                        reference="levelGroups"
                                        emptyText="-"
                                        link={false}
                                      >
                                        <TextField source="name" />
                                      </ReferenceField>
                                    </Grid>

                                    <Grid item xs={12} style={GridinRow}>
                                      <Typography variant="body2">
                                        Status : {student.status}
                                      </Typography>
                                    </Grid>

                                    {record.students.length - 1 !== index && (
                                      <Grid item xs={8}>
                                        <Divider />
                                      </Grid>
                                    )}
                                  </>
                                );
                              },
                            )}
                          </>
                        ) : (
                          <>
                            <Grid item xs={12}>
                              <Typography variant="body2">-</Typography>
                            </Grid>
                          </>
                        )}
                      </SanitizedGrid>
                    )}
                  </>
                )}
              />
              <StatusField source="status" />
            </Datagrid>
          </StyledList>
        </ResourceContextProvider>
      </Grid>
    </SanitizedGrid>
  );
};

export default PersonInCharge;
